import React from 'react'
import _ from 'underscore'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import Checkbox from '../checkbox'
import Modal from '../modal'
import JobReadiness from '../enquiry/lesson_plans/job_readiness'
import RequestPlacementPosition from './position'
import store from '../../state/store'

class RequestPlacement extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      accepted_position_ids: []
    }
  }

  onProceed = () => {
    store.emit('tutoring_jobs:request_placement')
  }

  onToggleSearch = () => {
    store.emit('ui:request_placement:toggle_search', !this.props.ui.request_placement.request_tutor_search)
  }

  onClose = () => {
    store.emit('ui:request_placement:close')
  }

  onSelectManager = (value) => {
    store.emit('ui:request_placement:select_manager', value)
  }

  onSelectMinutes = (value) => {
    store.emit('ui:request_placement:select_minutes', value)
  }

  render() {
    const { placement_managers, placement_manager_id, reserved_for_minutes } = this.props.ui.request_placement
    const selectedManager = _.find(placement_managers, (m) => String(m.id) === String(placement_manager_id))

    return (
      <Modal title="Send to Tutor Placement" subtitle="The client will be informed that placement has started." size="modal-lg" onClose={this.onClose}>
        <div className="grid gap-6 p-6 text-left">
          {this.props.lesson_plan &&
            <JobReadiness lesson_plan={this.props.lesson_plan} />
          }
          <div className="grid gap-2">
            <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Tutor Search</h4>
            <Checkbox name='Start Tutor Search' value="request_tutor_search" checked={this.props.ui.request_placement.request_tutor_search} onChange={this.onToggleSearch} label_weight={"normal"} />
          </div>
          <div className="grid gap-2">
            <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Find tutors for these subjects</h4>
            <div className="grid gap-1">
              {_.map(this.props.tutoring_job.tutoring_job_positions, (position) => {
                const selected = this.props.ui.request_placement.position_ids.includes(position.id)

                return (
                  <RequestPlacementPosition
                    key={position.id}
                    tutoring_job_position={position}
                    selected={selected}
                  />
                )
              })}
            </div>
          </div>
          <div className="grid gap-2">
            <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Assign to Placement Manager</h4>
            <Select
              value={placement_manager_id ? `${placement_manager_id}` : undefined}
              onValueChange={this.onSelectManager}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select a placement manager…"/>
              </SelectTrigger>
              <SelectContent>
                {_.map(placement_managers, (manager) => (
                  <SelectItem key={manager.id} value={`${manager.id}`}>
                    {manager.name} — {manager.active_request_count} active
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {selectedManager &&
              <div className="grid gap-2">
                <Label>Reserve for</Label>
                <Select
                  value={`${reserved_for_minutes}`}
                  onValueChange={this.onSelectMinutes}
                >
                  <SelectTrigger className="w-full">
                    <SelectValue/>
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="30">30 minutes</SelectItem>
                    <SelectItem value="60">1 hour</SelectItem>
                    <SelectItem value="120">2 hours</SelectItem>
                    <SelectItem value="240">4 hours</SelectItem>
                    <SelectItem value="480">8 hours</SelectItem>
                  </SelectContent>
                </Select>
                <span className="text-sm text-muted-foreground">
                  If {selectedManager.name} doesn't claim it within this time, it falls back to the placement backlog.
                </span>
              </div>
            }
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" size="sm" onClick={this.onClose}>Cancel</Button>
            <Button variant="success" size="sm" onClick={this.onProceed}>Send to Placement</Button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default RequestPlacement
